import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectServe from "@/components/SelectServe.vue";
import TreeSelect from "@/components/TreeSelect.vue";
import { getAllJobList } from "@/api/managementCenter/jobManage";
import { getDeptTree } from "@/api/managementCenter/otherApi";
import { hallSaveOrUpdate } from "@/api/managementCenter/chargeManage";
import quillEditorCom from "@/components/common/quillEditor.vue";
export default {
  name: "AppDialog",
  components: {
    SelectServe: SelectServe,
    TreeSelect: TreeSelect,
    quillEditorCom: quillEditorCom
  },
  props: [],
  data: function data() {
    return {
      type: "",
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      roleList: [],
      departmentData: [],
      show: false,
      loading: false,
      title: "",
      form: {
        id: "",
        respDeptId: "",
        deptIds: [],
        roleIds: [],
        rights: "",
        responseblity: "",
        serveIds: "",
        timeLimitType: ""
      },
      doubleSelect: [],
      serveList: [],
      rules: {
        respDeptId: [{
          required: true,
          message: "请选择责任部门",
          trigger: "blur"
        }],
        deptIds: [{
          required: true,
          message: "请选择关联部门",
          trigger: "blur"
        }],
        roleIds: [{
          required: true,
          message: "请选择岗位名称",
          trigger: "blur"
        }],
        rights: [{
          required: true,
          message: "请输入权利名称",
          trigger: "blur"
        }],
        responseblity: [{
          required: true,
          message: "请输入责任名称",
          trigger: "blur"
        }],
        serveIds: [{
          required: true,
          message: "请选择提供服务",
          trigger: "blur"
        }],
        timeLimitType: [{
          required: true,
          message: "请输入时效",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  methods: {
    getDeptTreeData: function getDeptTreeData() {
      var _this = this;

      getDeptTree().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          if (data.data && data.data.length > 0) {
            if (data.data[0].id == 1) {
              _this.departmentData = data.data[0].children;
            } else {
              _this.departmentData = data.data;
            }
          }

          if (_this.type == "edit") {
            _this.$nextTick(function () {
              // 编辑时部门回显
              _this.$refs.deptSingle.setKey(_this.form.respDeptId);

              _this.$refs.deptDouble.setKeys(_this.doubleSelect);
            });
          }
        }
      }).catch(function (err) {});
    },
    getAllJobListFn: function getAllJobListFn() {
      var _this2 = this;

      getAllJobList().then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this2.roleList = data.data.map(function (i) {
            return {
              roleName: i.postName,
              roleId: i.postId + ""
            };
          });
        }
      }).catch(function (err) {});
    },
    setDeptSingleMenu: function setDeptSingleMenu(key, data) {
      //获取子组件值
      this.form.respDeptId = data.id;
    },
    setDeptDoubleMenu: function setDeptDoubleMenu(key, data) {
      //获取子组件值
      this.doubleSelect = data.map(function (item) {
        return item.id;
      });
    },
    sureSelect: function sureSelect(data) {
      this.serveList = data;
    },
    serveSelect: function serveSelect() {
      this.$refs.selectServeRef.openDialog(this.serveList);
    },
    handleClose: function handleClose(tag) {
      this.serveList = this.serveList.filter(function (item) {
        return item.serve_id != tag.serve_id;
      });
    },
    // 显示弹框
    dialogShow: function dialogShow(type, data) {
      this.type = type; // 重置表单、显示弹框

      this.show = true;
      this.$nextTick(function () {
        this.$refs["ruleForm"].resetFields();

        switch (type) {
          case "add":
            this.title = "新增权责";
            this.form = {
              id: "",
              respDeptId: "",
              deptIds: [],
              roleIds: [],
              rights: "",
              responseblity: "",
              serveIds: "",
              timeLimitType: ""
            };
            break;

          case "edit":
            this.title = "编辑权责";
            this.form = {
              id: data.id,
              respDeptId: data.resp_dept_id,
              deptIds: [],
              roleIds: [],
              rights: data.rights,
              responseblity: data.responseblity,
              serveIds: "",
              timeLimitType: data.timeLimitType
            };
            this.doubleSelect = data.depts.map(function (i) {
              return i.id + "";
            }), this.form.roleIds = data.roles.map(function (i) {
              return i.id + "";
            });
            this.serveList = data.serves.map(function (i) {
              return {
                serve_id: i.id,
                server_name: i.name
              };
            });
            break;
        }
      });
    },
    saveOrUpdate: function saveOrUpdate() {
      var _this3 = this;

      this.loading = true;

      var params = _objectSpread(_objectSpread({}, this.form), {}, {
        serveIds: this.serveList.map(function (i) {
          return i.serve_id;
        }),
        deptIds: this.doubleSelect
      });

      hallSaveOrUpdate(params).then(function (_ref3) {
        var data = _ref3.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("保存成功!");

          _this3.show = false;

          _this3.$emit("saveSuccess");
        } else {
          _this3.$message.warning("保存失败!");
        }
      }).catch(function (err) {
        _this3.loading = false;

        _this3.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this4 = this;

      this.form.deptIds = this.doubleSelect.length > 0 ? "true" : "";
      this.form.serveIds = this.serveList.length > 0 ? "true" : "";
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.saveOrUpdate();
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        this.serveList = [];
        this.doubleSelect = [];
      } else {
        // 打开弹框时，获取岗位和角色数据
        this.getDeptTreeData();
        this.getAllJobListFn();
      }
    }
  },
  filters: {}
};